module.exports = __webpack_public_path__ + "img/instabank.1fa1552.png";